import React from "react";

type LoaderIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

const LoaderIcon = ({
  size = 18,
  color = "#9747FF",
  className,
}: LoaderIconProps) => {
  return (
    <span
      className={`loader ${className || ""}`}
      style={
        {
          "--loader-size": `${size}px`,
          "--loader-color": color,
        } as React.CSSProperties
      }
      aria-hidden="true"
    />
  );
};

export default LoaderIcon;
